import React, { useState } from 'react';
import { ShieldCheck, Users, Award, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function FooterTrust() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-cream-100 border-t border-brown-900/10 py-12" data-id="element-34">
        <div className="max-w-5xl mx-auto px-4" data-id="element-35">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-36">
            <div className="flex flex-col items-center gap-3" data-id="element-37">
              <div className="w-12 h-12 rounded-full bg-cream-200 flex items-center justify-center border border-brown-900/8" data-id="element-38">
                <ShieldCheck className="w-6 h-6 text-terra-500/80" data-id="element-39" />
              </div>
              <p className="text-brown-800 text-sm font-medium" data-id="element-40">
                Pago seguro encriptado.
              </p>
            </div>

            <div className="flex flex-col items-center gap-3" data-id="element-41">
              <div className="w-12 h-12 rounded-full bg-cream-200 flex items-center justify-center border border-brown-900/8" data-id="element-42">
                <Users className="w-6 h-6 text-terra-500/80" data-id="element-43" />
              </div>
              <p className="text-brown-800 text-sm font-medium" data-id="element-44">
                Más de 500 líderes ya han activado estos principios este mes.
              </p>
            </div>

            <div className="flex flex-col items-center gap-3" data-id="element-45">
              <div className="w-12 h-12 rounded-full bg-cream-200 flex items-center justify-center border border-brown-900/8" data-id="element-46">
                <Award className="w-6 h-6 text-terra-500/80" data-id="element-47" />
              </div>
              <p className="text-brown-800 text-sm font-medium" data-id="element-48">
                Satisfacción 100% garantizada.
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-brown-900/10 text-center space-y-4" data-id="element-49">
            <div className="flex items-center justify-center gap-6" data-id="element-50">
              <button onClick={() => setActiveModal('privacy')} className="text-sm text-brown-700 hover:text-terra-500 underline underline-offset-2 transition-colors" data-id="element-51">
                Política de Privacidad
              </button>
              <span className="text-brown-700/30" data-id="element-52">|</span>
              <button onClick={() => setActiveModal('terms')} className="text-sm text-brown-700 hover:text-terra-500 underline underline-offset-2 transition-colors" data-id="element-53">
                Términos y Condiciones
              </button>
            </div>
            <p className="text-xs text-brown-700/40" data-id="element-54">
              © {new Date().getFullYear()} El Código Celestial del Triunfo.
              Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Modal Popup */}
      <AnimatePresence data-id="element-55">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-brown-900/50 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-56">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-cream-50 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto border border-brown-900/10" onClick={e => e.stopPropagation()} data-id="element-57">
              <div className="sticky top-0 bg-cream-50 border-b border-brown-900/10 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-58">
                <h2 className="text-xl font-heading text-brown-900" data-id="element-59">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-1.5 rounded-full hover:bg-cream-200 transition-colors" aria-label="Cerrar" data-id="element-60">
                  <X className="w-5 h-5 text-brown-700" data-id="element-61" />
                </button>
              </div>

              <div className="px-6 py-6 text-brown-800 text-sm leading-relaxed space-y-4" data-id="element-62">
                {activeModal === 'privacy' ? <>
                    <p className="font-semibold text-brown-900" data-id="element-63">
                      Última actualización: Enero 2026
                    </p>
                    <p data-id="element-64">
                      En El Código Celestial del Triunfo, nos comprometemos a
                      proteger tu privacidad. Esta política describe cómo
                      recopilamos, usamos y protegemos tu información personal.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-65">
                      1. Información que Recopilamos
                    </h3>
                    <p data-id="element-66">
                      Recopilamos información que nos proporcionas directamente,
                      como tu nombre, dirección de correo electrónico y datos de
                      pago al realizar una compra. También podemos recopilar
                      información automáticamente, como tu dirección IP, tipo de
                      navegador y páginas visitadas.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-67">
                      2. Uso de la Información
                    </h3>
                    <p data-id="element-68">
                      Utilizamos tu información para procesar tus pedidos,
                      enviarte el contenido digital adquirido, comunicarnos
                      contigo sobre tu compra y mejorar nuestros productos y
                      servicios.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-69">
                      3. Protección de Datos
                    </h3>
                    <p data-id="element-70">
                      Implementamos medidas de seguridad técnicas y
                      organizativas para proteger tu información personal contra
                      acceso no autorizado, alteración, divulgación o
                      destrucción.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-71">
                      4. Compartir Información
                    </h3>
                    <p data-id="element-72">
                      No vendemos, intercambiamos ni transferimos tu información
                      personal a terceros sin tu consentimiento, excepto cuando
                      sea necesario para procesar tu pedido o cumplir con
                      requisitos legales.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-73">
                      5. Contacto
                    </h3>
                    <p data-id="element-74">
                      Si tienes preguntas sobre esta política de privacidad,
                      puedes contactarnos a través de nuestro correo electrónico
                      de soporte.
                    </p>
                  </> : <>
                    <p className="font-semibold text-brown-900" data-id="element-75">
                      Última actualización: Enero 2026
                    </p>
                    <p data-id="element-76">
                      Al acceder y utilizar este sitio web y adquirir nuestros
                      productos digitales, aceptas cumplir con estos términos y
                      condiciones.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-77">
                      1. Productos Digitales
                    </h3>
                    <p data-id="element-78">
                      Los productos ofrecidos incluyen libros digitales,
                      audiolibros y materiales complementarios en formato
                      digital. Una vez completada la compra, recibirás acceso
                      inmediato al contenido adquirido.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-79">
                      2. Política de Reembolso
                    </h3>
                    <p data-id="element-80">
                      Ofrecemos una garantía de satisfacción del 100%. Si no
                      estás satisfecho con tu compra, puedes solicitar un
                      reembolso completo dentro de los 30 días posteriores a la
                      fecha de compra.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-81">
                      3. Propiedad Intelectual
                    </h3>
                    <p data-id="element-82">
                      Todo el contenido, incluyendo textos, gráficos, logotipos
                      y material audiovisual, está protegido por derechos de
                      autor. No está permitida la reproducción, distribución o
                      reventa del contenido sin autorización expresa.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-83">
                      4. Uso Permitido
                    </h3>
                    <p data-id="element-84">
                      El contenido adquirido es para uso personal y no
                      comercial. No está permitido compartir, copiar o
                      distribuir el material a terceros.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-85">
                      5. Limitación de Responsabilidad
                    </h3>
                    <p data-id="element-86">
                      Los resultados pueden variar según cada individuo. No
                      garantizamos resultados financieros específicos. El
                      contenido tiene fines educativos e inspiracionales.
                    </p>
                    <h3 className="font-heading text-lg text-brown-900 pt-2" data-id="element-87">
                      6. Contacto
                    </h3>
                    <p data-id="element-88">
                      Para cualquier consulta sobre estos términos, puedes
                      comunicarte con nuestro equipo de soporte.
                    </p>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}